import baseAPI from '@/api/base';
import {
  EditTemplate,
  GetTemplate,
  RegisterTemplate,
} from '@/dtos/template.dto';
import {
  DELETE_TEMPLATE_URL,
  EDIT_TEMPLATE_URL,
  GET_TEMPLATE_URL,
  REGISTER_TEMPLATE_URL,
  TOGGLE_TEMPLATE_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Template {
  static getTemplates = async (
    getTemplate: GetTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_TEMPLATE_URL, {
      params: getTemplate,
    });
    console.log('response', response);
    return response;
  };

  static registerTemplate = async (
    registerTemplate: RegisterTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_TEMPLATE_URL,
      {
        ...registerTemplate,
      }
    );
    console.log('response', response);
    return response;
  };

  static editTemplate = async (
    editTemplate: EditTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_TEMPLATE_URL,
      {
        ...editTemplate,
      }
    );
    return response;
  };

  static toggleTemplateIsActive = async (
    editTemplate: EditTemplate
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_TEMPLATE_IS_ACTIVE_URL,
      {
        ...editTemplate,
      }
    );
    return response;
  };

  static deleteTemplate = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_TEMPLATE_URL}/${id}`
    );
    return response;
  };
}

export default Template;
